<template>
  <div
    class="base-card print-break-inside-avoid"
    :class="{'base-card--gray': gray}"
  >
    <a
      :href="fullLinkUrl"
      :target="target"
      class="base-card__link"
    >

      <div class="base-card__image-wrap">
        <div
          class="base-card__image"
          :style="`background-image: url(${urlImage})`"
        />

        <!-- Top left wrapper for badges -->
        <div class="base-card__top-left-wrapper">

          <!-- Occupancy e.g. Omistus -->
          <div
            v-if="badge"
            class="skewed-rectangle"
          >
            <span class="skewed-rectangle__text">
              {{badge.text}}
            </span>
          </div>

          <!-- Oma tontti -->
          <div
            v-if="ownPlot && housingType == 'owner-occupancy'"
            class="skewed-rectangle skewed-rectangle--green skewed-rectangle--flat"
          >

            <span class="skewed-rectangle__text">
              {{translate('Oma tontti')}}
            </span>
          </div>


          <div
            v-if="incomeLimit"
            class="skewed-rectangle skewed-rectangle--green skewed-rectangle--flat"
          >
            <span class="skewed-rectangle__text">
              {{translate('Tulorajat')}}
            </span>
          </div>

          <div
            v-if="meansTest"
            class="skewed-rectangle skewed-rectangle--green skewed-rectangle--flat"
          >
            <span class="skewed-rectangle__text">
              {{translate('Tarveharkinta')}}
            </span>
          </div>

        </div>

        <div
          class="base-card__hover"
          :class="`base-card__hover--${badge.color}`"
        >
          {{hoverText}}
          <ArrowIcon />
        </div>

        <slot name="afterImage"/>
      </div>

      <!-- Content & specs section -->
      <div class="base-card__content">
        <div class="base-card__header">
          <slot
            name="default"
            title="base-card__title"
            line="base-card__line"
          />
        </div>

        <slot name="apartmentSpecs"/>

        <div class="base-card__footer">
            <slot name="footer"/>
        </div>
      </div>
    </a>

    <slot name="afterLink"/>
  </div>
</template>

<script>
  import ArrowIcon from '../icons/ArrowIcon.vue';
  import utils from '../mixins/utils';

  export default {
    mixins: [
      utils.translate,
    ],
    props: {
        urlLink: {
            type: String,
            required: true,
        },
        urlImage: {
            type: String,
            default: null,
        },
        getParams: {
            type: Object,
            default: null,
        },
        badge: {
            type: Object,
            default: null,
        },
        housingType: {
            type: String,
            default: null,
        },
        meansTest: {
            type: Boolean,
            default: false,
        },
        incomeLimit: {
            type: Boolean,
            default: false,
        },
        ownPlot: {
            type: Boolean,
            default: false,
        },
        gray: {
            type: Boolean,
            default: false,
        },
        target: {
            type: String,
            default: "_self",
        },
        hoverText: {
            type: String,
            required: true,
        },
    },
    computed: {
        fullLinkUrl() {
            if (!this.getParams) {
                return this.urlLink;
            }
            // https://stackoverflow.com/a/18116302
            const queryString = Object.keys(this.getParams)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.getParams[key])}`)
                .join("&");
            return `${this.urlLink}?${queryString}`;
        },
    },
    components: { ArrowIcon }
}
</script>

<style lang="scss">
  @import "~styles/definitions";

  .base-card {
    @include card;
    position: relative;
    display: flex;
    flex-flow: column;
    background-color: $color-white;
    transition: background-color 0.2s;

    &--gray {
      background-color: #f0f0f0;
    }
  }

  .base-card__content {
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    padding: .5rem 1.75rem;
  }

  .base-card__link {
    flex: 1 0 auto;
    display: flex;
    flex-grow: 1;
    width: 100%; // ie
    flex-direction: column;
  }

  .base-card__header {
    padding-top: r(4);
    margin-bottom: .5rem;
  }

  .base-card__line {
    @include font-body-16;
    font-weight: $font-weight-bold;
    line-height: r(22);
    margin-bottom: .5rem;
  }

  .base-card__title {
    display: flex;
    font-family: $ff-lato;
    font-weight: $font-weight-bold;
    color: $black;
    font-size: r(20);
    line-height: r(20);
  }

  .base-card__image-wrap {
    position: relative;
    margin: 0;
  }

  .base-card__image {
    @include bg-cover;
    height: r(232);
  }

  .base-card__top-left-wrapper {
    position: absolute;
    top: r(12);
    left: r(12);
    display: flex;
    flex-flow: column;

    .skewed-rectangle {
      margin-bottom: .5rem;

      &:last-child {
        margin-bottom :0;
      }
    }
  }

  .base-card__badge {

  }

  .base-card__hover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    @include font-h-28;
    z-index: 1;
    display: flex;
    right: 0;
    bottom: 0;
    align-items: center;
    justify-content: center;
    visibility: hidden;
    opacity: 0;
    text-align: center;
    color: $color-white;
    transition: opacity 0.2s, visibility 0.2s;
    background-color: rgba($color-green-2025, 0.5);

    .base-card__link:hover & {
      opacity: 1;
      visibility: visible;
    }
  }

  .base-card__infobox-wrap {
/*     position: absolute;
    top: r(12);
    right: r(12); */
  }

  .base-card__infobox {
      color: $white;
      background-color: $color-green-2025;
      text-align: center;
      font-size: r(12);
      font-weight: bold;
      padding: r(6) r(16);
      margin-bottom: r(8);
      
      &--pink {
        background-color: rgba($color-pink, 1);
      }

      &--yellow {
        background-color: rgba($color-yellow, 1);
      }

      &--blue {
        background-color: rgba($color-blue, 1);
      }
  }

  .base-card {

    &__specs {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding: r(8) 0;
      @include font-label-14;
      font-weight: 900;

      .icon {
        margin-right: .5rem;
      }
    }

    &__specs--row {
      align-items: center;
    }

    &__specs-item {
      display: flex;
      align-items: center;
      margin-bottom: .5rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__specs-item-inner {
      display: flex;
      align-items: center;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .base-card__separator {
    padding: 0 .25rem;
  }

  .base-card__footer {
    display: flex;
    align-items: center;
    margin-bottom: .5rem;
  }
</style>
